/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Regions_FoundInputs */

const en_no_regions_found = /** @type {(inputs: No_Regions_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No regions found.`)
};

const es_no_regions_found = /** @type {(inputs: No_Regions_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron regiones.`)
};

/**
* | output |
* | --- |
* | "No regions found." |
*
* @param {No_Regions_FoundInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const no_regions_found = /** @type {((inputs?: No_Regions_FoundInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Regions_FoundInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_regions_found(inputs)
	return es_no_regions_found(inputs)
});